import { getBooleanValue } from '../../../../../shared/api/session/getBooleanValue.js';

export const REGISTER_SESSION_TYPE_TOKEN = 'Bearer';
export const SAML_ACCESS = 'saml';
export const ACCOUNTS_ACCESS = 'accounts';
export const CRYPT_ACCESS = 'crypt';
export const CERT_ACCESS = 'cert';

// 11/2023: Aceptamos password encriptado (de momento no hacemos nada especial con ese tipo)
// 03/2024: La parte con sessionInfo sólo aplica al login
export function getTypeAccess(params, sessionInfo) {
  if (getBooleanValue(params?.samlAccess)) {
    return SAML_ACCESS;
  } else if (params?.token_type === REGISTER_SESSION_TYPE_TOKEN) {
    return ACCOUNTS_ACCESS;
  } else if (params?.cryptAccess) {
    return CRYPT_ACCESS;
  } else if (getBooleanValue(params?.certAccess) || sessionInfo?.eidasRequired || sessionInfo?.certAllowed) {
    // 04/2024: eidasRequired = certAllowed + createUser
    return CERT_ACCESS;
  }

  return '';
}
